module.exports = __webpack_public_path__ + "static/media/customer-pind.4d8bfd0d.png";